import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NAV_ITEMS, activeNavForPath } from './PageBanner';
import './topHeader.css';

/**
 * The section nav in the top bar — HOME · EVENTS · CLUBS · FRIENDS · CALENDAR (desktop only; below lg
 * the floating bottom nav is the nav). Top-header handoff §3 (Sept 25 2026).
 *
 * A #161616 pill track; each link a 36px pill. The current one takes the ON state (black inside
 * the RING), the rest are #A3A3A3 and go #262626 / white on hover. CREATE and HOST are no longer
 * in the nav — they sit in the right group as their own circles.
 */
const ORDER = ['home', 'events', 'clubs', 'people', 'calendar'];

export default function HeaderNav({ pad = 16, className = '' }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const current = activeNavForPath(pathname);
  const items = ORDER.map((k) => NAV_ITEMS.find((t) => t.key === k));

  return (
    <nav aria-label="Primary" className={`th-nav ${className}`} style={{ '--th-nav-pad': `${pad}px` }}>
      {items.map((t) => (
        <button
          key={t.key}
          type="button"
          data-portal-to={t.path}
          onClick={() => navigate(t.path)}
          aria-current={current === t.key ? 'page' : undefined}
          className="th-nav-link font-mono"
        >
          {t.label}
        </button>
      ))}
    </nav>
  );
}
